import React from 'react';
import { Outlet } from 'react-router';
import PreviewModeToggleNavigation from '../../components/PreviewModeToggleNavigation';
import PreviewPatchListingProvider from '../../providers/PreviewPatchListing';

const ProfitableGoingConcern: React.FC = () => {
  return (
    <PreviewPatchListingProvider>
      <PreviewModeToggleNavigation />
      <Outlet />
    </PreviewPatchListingProvider>
  );
};

export default ProfitableGoingConcern;
